import { useLang } from "@/i18n/LanguageContext";
import { SEO } from "@/components/site/SEO";
import { RevealSection } from "@/components/site/RevealSection";

export default function Privacy() {
  const { t, lang } = useLang();
  const privacy = t.privacy;

  return (
    <div className="bg-paper text-ink pt-32 pb-24 min-h-screen">
      <SEO title={privacy.meta.title} description={privacy.meta.description} lang={lang} />
      <RevealSection className="max-w-3xl mx-auto px-6 md:px-12">
        <h1 className="font-heading italic text-3xl md:text-5xl text-ink" data-testid="privacy-title">
          {privacy.title}
        </h1>
        <p className="mt-4 font-mono text-xs text-muted">{privacy.updated}</p>
        <div className="mt-10 space-y-5" data-testid="privacy-body">
          {privacy.body.map((p, i) => (
            <p key={i} className="font-body text-base text-secondary leading-relaxed">
              {p}
            </p>
          ))}
        </div>
      </RevealSection>
    </div>
  );
}
